$(document).ready(function(){

	$('.bundle-select').on('change', function(e){
		$(this).parent().parent().addClass('active').siblings().removeClass('active');
        var qty = $(this).val();
        $('.product-input-qty').val(qty);

        // var id = $(this).parent().parent().data('id');

        // var variant_id = $('.bundle_variant_1').find(":selected").data('id');
        // var variant_id2 = $('.bundle_variant_2').find(":selected").data('id');
        // var variant_id3 = $('.bundle_variant_3').find(":selected").data('id');
        // var variant_id4 = $('.bundle_variant_4').find(":selected").data('id');
        // var variant_id5 = $('.bundle_variant_5').find(":selected").data('id');
        // var variant_id6 = $('.bundle_variant_6').find(":selected").data('id');

        // console.log('id ' + id)

        // if(id == 1) {
        //     $('#bundle_product_id').val(variant_id);
        //     $('#bundle_product_id2').prop('checked', false); 
        //     $('#bundle_product_id3').prop('checked', false);
        // } else if (id == 2) {
        //     $('#bundle_product_id').val(variant_id2).prop('checked', true);
        //     $('#bundle_product_id2').val(variant_id3).prop('checked', true);
        //     $('#bundle_product_id3').prop('checked', false);
        // }else if (id == 3) {
        //     $('#bundle_product_id').val(variant_id4).prop('checked', true);
        //     $('#bundle_product_id2').val(variant_id5).prop('checked', true);
        //     $('#bundle_product_id3').val(variant_id6).prop('checked', true);
        // }
	})

	$('.bundle_option').on('change', function(e){
        var option_name = '';

        $(this).parent().parent().find('.bundle_option').each(function(e){
            option_name += e != 0 ? ''+'-' + '' : '';
            option_name += $.trim($(this).val());
        });

        $(this).parent().parent().find('.bundle_variants option').each(function(){
			var txt = $.trim($(this).val()); 
			if(txt == option_name ){
				
				var id = $(this).data('id');  
				var img =  $(this).data('img'); 
				var bundle =  $(this).data('bundle'); 
                var price = $(this).data('price');
                var compare_price = $(this).data('compare');
				var save_price = ((compare_price - price)*0.01).toFixed(2);
				// if(compare_price>0){					
				// 	$('.compare-price').text(currency + (compare_price*0.01).toFixed(2));
				// 	$('.regular-price, span.product-final-price').text(currency + (price*0.01).toFixed(2));
				// 	$('.single-save-price').removeClass('hide').text('SAVE ' + currency + save_price);
				// }else {            
				// 	$('.single-save-price').addClass('hide');            
				// 	$('.regular-price, span.product-final-price').text(currency + (price*0.01).toFixed(2));
				// }
                console.log('bundle ' + bundle);

                var variant_id = $('.bundle_variant_1').find(":selected").data('id');
                var variant_id2 = $('.bundle_variant_2').find(":selected").data('id');
                var variant_id3 = $('.bundle_variant_3').find(":selected").data('id');
                var variant_id4 = $('.bundle_variant_4').find(":selected").data('id');
                var variant_id5 = $('.bundle_variant_5').find(":selected").data('id');
                var variant_id6 = $('.bundle_variant_6').find(":selected").data('id');

                var stock = $(this).data('stock');                         
                var stock1 = $('.bundle_variant_1').find(":selected").data('stock');
                var stock2 = $('.bundle_variant_2').find(":selected").data('stock');
                var stock3 = $('.bundle_variant_3').find(":selected").data('stock');
                var stock4 = $('.bundle_variant_4').find(":selected").data('stock');
                var stock5 = $('.bundle_variant_5').find(":selected").data('stock');
                var stock6 = $('.bundle_variant_6').find(":selected").data('stock');

                if( stock != true ) {
                    $(this).parent().next().css('display','block');		
                }else {
                    $(this).parent().next().css('display','none');	
                }

                var message = $(this).parent().next();
                if(bundle == 1) {
                    $('#bundle_product_id').val(id);
                    $('#bundle_product_id2').prop('checked', false);
                    $('#bundle_product_id3').prop('checked', false);

                    if(stock != true ){
                        $('.addToCart').addClass('sold_out');					
                        $('.cta-btn').text('SOLD OUT');		
                    }else{
                        $('.addToCart').removeClass('sold_out');
                        $('.cta-btn').text('ADD TO CART');
                    }

                } else if (bundle == 2) {
                    $('#bundle_product_id').val(id);
                    $('#bundle_product_id2').val(variant_id3).prop('checked', true);
                    $('#bundle_product_id3').prop('checked', false);
                    
                    if(stock != true || stock3 != true ){
                        $('.addToCart').addClass('sold_out');					
                        $('.cta-btn').text('SOLD OUT');					
                    }else{
                        $('.addToCart').removeClass('sold_out');
                        $('.cta-btn').text('ADD TO CART');	
                    }
                    
                } else if (bundle == 3) {
                    $('#bundle_product_id').val(variant_id2).prop('checked', true);
                    $('#bundle_product_id2').val(id); 
                    $('#bundle_product_id3').prop('checked', false);

                    if(stock != true || stock2 != true ){
                        $('.addToCart').addClass('sold_out');					
                        $('.cta-btn').text('SOLD OUT');		
                    }else{
                        $('.addToCart').removeClass('sold_out');
                        $('.cta-btn').text('ADD TO CART');
                    }
                } else if (bundle == 4) {
                    $('#bundle_product_id').val(id);
                    $('#bundle_product_id2').val(variant_id5).prop('checked', true);
                    $('#bundle_product_id3').val(variant_id6).prop('checked', true);

                    if(stock != true || stock5 != true || stock6 != true ){
                        $('.addToCart').addClass('sold_out');					
                        $('.cta-btn').text('SOLD OUT');				
                    }else{
                        $('.addToCart').removeClass('sold_out');
                        $('.cta-btn').text('ADD TO CART');	
                    }
                } else if (bundle == 5) {
                    $('#bundle_product_id').val(variant_id4).prop('checked', true);
                    $('#bundle_product_id2').val(id);
                    $('#bundle_product_id3').val(variant_id6).prop('checked', true);

                    if(stock != true || stock4 != true || stock6 != true ){
                        $('.addToCart').addClass('sold_out');					
                        $('.cta-btn').text('SOLD OUT');				
                    }else{
                        $('.addToCart').removeClass('sold_out');
                        $('.cta-btn').text('ADD TO CART');	
                    }
                } else if (bundle == 6) {
                    $('#bundle_product_id').val(variant_id4).prop('checked', true);
                    $('#bundle_product_id2').val(variant_id5).prop('checked', true);
                    $('#bundle_product_id3').val(id);

                    if(stock != true || stock4 != true || stock5 != true ){
                        $('.addToCart').addClass('sold_out');					
                        $('.cta-btn').text('SOLD OUT');					
                    }else{
                        $('.addToCart').removeClass('sold_out');
                        $('.cta-btn').text('ADD TO CART');	
                    }
                }        
				$('.slick-active .featured-img').attr('src', img);
				$(this).parent().val($(this).val());
			} 
		}) 
	})
})